import { shortDateOf } from "@repo/helpers";
import { DropDownList } from "@repo/ui";
import { FC, useMemo } from "react";

import { useRepQueries } from "../../api/repApi";
import { useOnboardingContext } from "../../contexts/onboardingContext";
import { useSegmentContext } from "../../contexts/segmentContext";
import OnboardingSession from "../../models/onboardingSession";
import style from "./style.module.scss";

export const OnboardingSessions: FC = () => {
	const { useOnboardingSessionsQuery } = useRepQueries();
	const { data: obSessions } = useOnboardingSessionsQuery();
	const { sessionId, setSessionId } = useOnboardingContext();
	const { segmentId } = useSegmentContext();

	const mappedSessions = useMemo(() => {
		if (!obSessions) return [];
		if (!segmentId) return obSessions.map(formatSession);
		return obSessions.filter((s) => s.repSegmentIds.includes(segmentId)).map(formatSession);
		function formatSession(session: OnboardingSession) {
			return {
				value: session.id,
				label: `${session.template.name} - ${shortDateOf(session.createdOn)} - ${session.id}`,
			};
		}
	}, [obSessions, segmentId]);

	if (mappedSessions.length <= 1) return null;

	return (
		<DropDownList
			id="obSession"
			label="Sessions"
			value={sessionId}
			changeHandler={setSessionId}
			values={mappedSessions}
			clearable
			className={style.dropdownList}
			fullLength
		/>
	);
};
